// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"647":"8bacd495","894":"8bacd495"}[chunkId] + ".chunk.css";
};